import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon DesktopDuotone
 */
export const DesktopDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M46.7,144.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0C34.5,149.9,40,144.4,46.7,144.4  M46.7,134.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0C69,144.3,59,134.4,46.7,134.4z"
      fill="currentColor"
    />
    <path
      d="M127.7,144.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,149.9,121,144.4,127.7,144.4 M127.7,134.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C150,144.3,140,134.4,127.7,134.4z"
      fill="currentColor"
    />
    <path
      d="M209.7,144.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,149.9,203,144.4,209.7,144.4 M209.7,134.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C232,144.3,222,134.4,209.7,134.4z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.7,144.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C34.5,149.9,40,144.4,46.7,144.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M127.7,144.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,149.9,121,144.4,127.7,144.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.7,144.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,149.9,203,144.4,209.7,144.4"
      fill="currentColor"
    />
    <path d="M227.5,87.1v23h-199v-23H227.5 M237.5,77.1h-219v43h219V77.1z" fill="currentColor" />
    <path className="st0" d="M227.5,87.1v23h-199v-23H227.5" fill="currentColor" />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default DesktopDuotone;
